import config from '../data/config.json';
import dict from '../data/dictionary.json';

import L from 'leaflet';
import Mustache from 'mustache';

import { Solr, Sesion } from '../main.js';
import { Mimapa } from './map.js';
import { sugeLugaresTemplate } from '../data/htmlTemplates.js';
import { getLiteral } from './util.js';
import { sendEvent } from './events.js';

let iconoLugar;

///////////////////////////////////////////////
// RENDER DEL BOTÓN Y CAJETÍN DE BUSCAR LUGARES
function activarEntradaLugares() {
	// muestro botón
	document.querySelector(".div-buscar").classList.remove('d-none');

	// detecto cambios en la entrada de lugares
	// "search" es para detectar si el usuario hizo click en la X del formulario (clear button)
	document.getElementById("in_lugares").addEventListener("keyup", async function(e) {
		handleInputEvent(e);
	});
	document.getElementById("in_lugares").addEventListener("search", async function(e) {
		handleInputEvent(e);
	});
	async function handleInputEvent(e) {
		// primero recupero la entrada
		const entrada = document.getElementById("in_lugares").value;
		// trato las teclas de arriba, abajo y enter			
		if (e.which === 13) { // ENTER key
				// sólo actúo si hay al menos una sugerencia (y habilitada)
			if (Array.from(document.getElementById("sugelugares").children).filter(child => !child.disabled).length > 0) {
				// si no había ninguna sugerencia seleccionada activo la primera
				if (Sesion.lugarfocus === -1) {
					Sesion.lugarfocus = 0;
					ajustarLugarfocus();
				}
					// y ahora vamos al lugar seleccionado
				Array.from(document.getElementById("sugelugares").children).filter(child => !child.disabled)[Sesion.lugarfocus].click();
			}
		} else if (e.which === 40) { // DOWN arrow key
			// incremento focus
			Sesion.lugarfocus++;
			ajustarLugarfocus();
		} else if (e.which === 38) { // UP arrow key
			// decremento focus
			Sesion.lugarfocus--;
			ajustarLugarfocus();
		} else if (e.which !== undefined) { // Normal case
			// si había marcador de municipio, lo quito
			if (Sesion.lugarmarker) {
				Sesion.lugarmarker.remove();
				Sesion.lugarmarker = null;
				Sesion.lugar = null;
			}
			// actúo según la entrada
			if (entrada.length === 0) { // No input
				document.getElementById("sugelugares").innerHTML = "";
				document.getElementById("sugelugares").classList.add("d-none");
			} else { // obtengo sugerencias y hago su render
				document.getElementById("sugelugares").classList.remove("d-none");
				const sugs = await obtenerSugerenciasLugares(entrada);
				renderSugerenciasLugares(sugs);
			}
		} else {
			// caso de la X del formulario... (quito las sugerencias y el marcador si lo hay)
			if (entrada.length === 0) { // No input
				document.getElementById("sugelugares").innerHTML = "";
				document.getElementById("sugelugares").classList.add("d-none");
				if (Sesion.lugarmarker !== null) {
					Sesion.lugarmarker.remove();
					Sesion.lugarmarker = null;
					Sesion.lugar = null;
				}
			}
		}
	}

	// Handle focusin event
	document.getElementById("in_lugares").addEventListener("focusin", function() {
		// vuelve el focus, muestro las sugerencias si hay algo
		const entrada = document.getElementById("in_lugares").value;
		if (entrada.length > 0) 
			document.getElementById("sugelugares").classList.remove("d-none");
	});

	// Handle focusout event
	document.getElementById("in_lugares").addEventListener("focusout", function() {
		// si pierde el focus escondemos las sugerencias tras un delay
		// el delay es importante para que se pueda clickar un botón antes de eliminar las sugerencias
		setTimeout(function() {
			if (!document.getElementById("in_lugares").matches(":focus")) // si vuelve el focus no escondo
				document.getElementById("sugelugares").classList.add("d-none");
		}, 300);
	});
}

///////////////////////////
// OBTENCIÓN DE SUGERENCIAS
async function obtenerSugerenciasLugares(entrada) {
	try {
		// hago la llamada a solr y espero resultados
		const datos = await Solr.getSuggestions(entrada);
		// extraigo sugerencias
		let keys = Object.keys(datos.suggest.mySuggester);
		if (keys.length > 0) 
			return datos.suggest.mySuggester[keys[0]];
		else // si no hay resultados, mando un objeto nuevo
			return {'numFound': 0};
	} catch(err) {
		reject(err);
	}
}

/////////////////////
// RENDER SUGERENCIAS
function renderSugerenciasLugares(resultados) {
	// objeto sugerencias
	let sinfo = {};
	sinfo.sugerencias = [];
	
	// formateo las sugerencias
	if (resultados.numFound == 0)
		sinfo.nosugerencias = true;
	else {
		for (let ind =0; ind < resultados.suggestions.length; ind++) {
			sinfo.sugerencias.push(
				{
					'id': resultados.suggestions[ind].payload, // el id
					'name': resultados.suggestions[ind].term // la sugerencia
				}
			);
		}
	}
	
	// muestro sugerencias
	let cont = Mustache.render(sugeLugaresTemplate, sinfo);
	document.getElementById("sugelugares").innerHTML = cont;
		
	// handler de los botones de sugerencias de lugares
	document.querySelectorAll(".bot_suge_lugar").forEach(function(button) {
		button.addEventListener('click', async function() {
			// obtengo id de la sugerencia
			const id = this.getAttribute("id");
			// pedimos la información del lugar
			const datos = await Solr.getDocument(id);
			// si hay algo, vamos al primero
			if (datos.response.numFound > 0)
				seleccionarLugar(datos.response.docs[0]);
		});
	});
	
	// inicializo focus
	Sesion.lugarfocus = -1;
}

///////////////
// AJUSTE FOCUS
function ajustarLugarfocus() {
	// Sesion.lugarfocus = 0; => cajetín entrada
	// Sesion.lugarfocus = i; => num de sugerencia
	// obtengo número de sugerencias
	const ns = Array.from(document.getElementById("sugelugares").children)
		.filter(child => !child.disabled).length;
	// reajusto índice del focus si hace falta
	if (ns == 0) Sesion.lugarfocus = -1;
	else if (Sesion.lugarfocus >= ns) Sesion.lugarfocus = 0;
	else if (Sesion.lugarfocus < 0) Sesion.lugarfocus = ns -1;
	// y ahora las cosas visuales
	Array.from(document.getElementById("sugelugares").children).forEach(function(child) {
        child.classList.remove("active");
    });
	if (Sesion.lugarfocus >= 0)
		document.getElementById("sugelugares").children[Sesion.lugarfocus].classList.add("active");
}

////////////////////
// SELECCIONAR LUGAR
function seleccionarLugar(lugar) {
	// pongo nombre	en la entrada
    document.getElementById("in_lugares").value = lugar.name;
	
	// escondo la lista de sugerencias
    document.getElementById("sugelugares").classList.add("d-none");
	
	// inicializo focus
	Sesion.lugarfocus = -1;
	
	// si había marcador de lugar, lo quito
	if (Sesion.lugarmarker)
		Sesion.lugarmarker.remove();
		
	// pongo tooltip y marcador en el lugar
	let tooltip = '<strong>'+lugar.name+'</strong>';
	// pongo el tipo de lugar
	tooltip += '<br>' + getLiteral(dict[lugar.feature_code]);
	// población
	if (lugar.population > 0)
		tooltip += '<br>'+getLiteral(dict.population)+': '+Number(lugar.population).toLocaleString();
	// coordenadas
	const coords = [lugar.latitude, lugar.longitude];
	// pongo marcador
	if (!iconoLugar) {
		iconoLugar = new L.Icon({
			iconUrl: new URL('../images/marker-icon-2x-blue.png', import.meta.url),
			shadowUrl: new URL('../images/marker-shadow.png', import.meta.url),
			iconSize: [25, 41],
			iconAnchor: [12, 41],
			popupAnchor: [1, -34],
			shadowSize: [41, 41]
		});	
	}	
	Sesion.lugarmarker = L.marker(coords, {icon: iconoLugar})
		.bindTooltip(tooltip)
		.addTo(Mimapa);
		
	// guardo lugar en la sesión (para poder hacer un zoom si se pulsa intro en la entrada)
	Sesion.lugar = lugar;
	
	// mando evento de selección de lugar a GA
	sendEvent( 'select_content', { content_type: 'place_selection', content_id: lugar.name } );
	
	// navegamos al municipio
	Mimapa.flyTo(coords, config.zLugar, {animate: true, duration: 0.5});
}

export { activarEntradaLugares, obtenerSugerenciasLugares, renderSugerenciasLugares, ajustarLugarfocus };